export enum FieldType {
  CoordinateMgrs = 'coordinate_mgrs',
  CoordinateAny = 'coordinate_any',
  CoordinateDD = 'coordinate_dd',
  CoordinateDMS = 'coordinate_dms',
  GeoJsonPolygon = 'geojson_polygon',
  GeoJsonPoint = 'geojson_point',
  GeoJsonLinestring = 'geojson_linestring',
  GeoJsonGeometry = 'geojson_geometry',
  Bbox = 'bbox',
  MgrsList = 'mgrs_list',
  Text = 'text',
  Number = 'number',
  Select = 'select',
  Textarea = 'textarea',
  Date = 'date',
  Datetime = 'datetime',
  Boolean = 'boolean',
}

export interface TemplateField {
  id: string
  label: string
  type: FieldType | string  // allow unknown types — degrade gracefully
  required?: boolean
  description?: string
  placeholder?: string
  options?: string[]       // for select fields
  value?: unknown          // populated on submission
}

export interface TemplateMeta {
  name: string
  version: string
  description?: string
  classification?: string
  tags?: string[]
}

export interface TemplateJson {
  $schema?: string
  meta: TemplateMeta
  fields: TemplateField[]
  [key: string]: unknown   // preserve extra top-level keys
}

/** Runtime representation with user-filled values */
export type FilledTemplate = TemplateJson & {
  _geometry?: {
    primary: import('./geo').GeoJsonGeometry | null
    all_geo_fields: Array<{
      field_id: string
      label: string
      value: unknown
    }>
  }
}
